export const colorSchema = {
  A: "#0047AB", // Cobalt Blue
  B: "#9A2A2A", // Garnet
  C: "#3CB371", // Medium Sea Green
  D: "#6A5ACD", // Amethyst
  E: "#9B2335", // Velvet Red
  F: "#6C2A2A", // Oxide Red
  G: "#8B008B", // Dark Magenta
  H: "#FF69B4", // Hot Pink
  I: "#3E8E41", // Hunter Green
  J: "#001F3F", // Navy
  K: "#D21F3C", // Raspberry
  L: "#C04000", // Mahogany
  M: "#9B2D51", // Quinacridone Magenta
  N: "#4B0082", // Indigo
  O: "#D24D00", // Terracotta
  P: "#4682B4", // Steel Blue
  Q: "#663399", // Lavender
  R: "#6F2C91", // Berry Purple
  S: "#D6A72D", // Yellow Ochre
  T: "#635147", // Umber
  U: "#722F3F", // Wine
  V: "#B22222", // Firebrick
  W: "#228B22", // Forest Green
  X: "#0047AB", // Xenon Blue
  Y: "#8B008B", // Dark Magenta
  Z: "#C04000", // Mahogany
};

export const chartColorOptions = [
  "#DD5F5F", // Soft Coral Red
  "#DD7E5F", // Warm Terracotta
  "#DD9D5F", // Golden Ochre
  "#DDBC5F", // Muted Sunflower
  "#DDDB5F", // Soft Pear Green
  "#BCDD5F", // Pale Lime
  "#9DDD5F", // Spring Leaf
  "#7EDD5F", // Soft Emerald
  "#5FDD5F", // Classic Pastel Green
  "#5FDD7E", // Minty Sage
  "#5FDD9D", // Seafoam Green
  "#5FDDBC", // Aqua Marine
  "#5FDDDB", // Soft Cyan
  "#5FBCDD", // Sky Blue
  "#5F9DDD", // Cornflower Blue
  "#5F7EDD", // Periwinkle
  "#5F5FDD", // Soft Royal Blue
  "#7E5FDD", // Lavender Purple
  "#9D5FDD", // Bright Amethyst
  "#BC5FDD", // Orchid Pink-Purple
  "#DD5FDB", // Soft Magenta
  "#DD5FBC", // Rose Pink
  "#DD5F9D", // Warm Raspberry
  "#DD5F7E", // Soft Crimson
];

export const placeholderImagesToSkip = [
  "https://static.licdn.com/aero-v1/sc/h/9c8pery4andzj6ohjkjp54ma2",
  "https://static.licdn.com/sc/h/244xhbkr7g40x6bsu4gi6q4ry",
  "https://static.licdn.com/aero-v1/sc/h/244xhbkr7g40x6bsu4gi6q4ry",
  "https://static-exp1.licdn.com/sc/h/djzv59yelk5urv2ujlazfyvrk",
];
